const enum Conditions {
  MENOPAUSAL_SUPPORT = "Menopausal support",
  MENOPAUSE = "Menopause",
}

export const SpotlightConditions: string[] = [Conditions.MENOPAUSAL_SUPPORT, Conditions.MENOPAUSE];

type ConditionCampaignType = Conditions;

interface CampaignData {
  banner: {
    title: string;
    description: string;
    image: string;
  };
  template: {
    title: string;
    description: string;
    slug: string;
  };
  ingredients: {
    keys: Record<string, string>[];
    parentTaxonomy: string;
  };
  popularProducts: {
    skus: string[];
    title: string;
  };
}

export { type ConditionCampaignType, type CampaignData, Conditions };
